<div>
  <h1 class="section-header"><strong>Search Results</strong></h1>
  <hr />
  <ngx-datatable
    class="bootstrap striped"
    #table
    [rows]="results"
    [columnMode]="'force'"
    [headerHeight]="'auto'"
    [footerHeight]="50"
    [rowHeight]="'auto'"
    [limit]="5"
  >
    <ngx-datatable-column name="Person Name">
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        @if (row.details && row.details.length > 0) {
        <div>
          @for (ind of row.details; track ind) {
          <div class="pb-3">
            <div>{{ ind.name }}</div>
            <div>{{ ind.dob | date: "MM/dd/yyyy" }}</div>
          </div>
          }
        </div>
        }
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Submission Type">
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        @if (submissionType && submissionType.code === 'AD') {
        <span>Additional Document</span>
        } @if (!submissionType) {
        <span>{{ row?.submissionType?.value }}</span>
        }
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Submission Date">
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        @if (row?.subdate) {
        <span>{{ row.subdate | date: "MM/dd/yyyy" }}</span>
        } @if (!row?.subdate) {
        <span>{{ "Unavailable" | translate }}</span>
        }
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Submitted By">
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        @if (!row?.wpAppNum) {
        <span>N/A</span>
        } @if (row?.wpAppNum) {
        <span>{{ row.subBy }}</span>
        }
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column [width]="200" name="Upload Documents">
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        @if (row?.memberSearchResponse && row.flagStatus) {
        <span>
          @for (ind of row.details; track ind) {
          <div>
            @if (ind.form2350 === 'Y') {
            <div>
              <button
                (click)="admitDischarge(ind)"
                class="btn btn-secondary upload-btn"
              >
                Form 2350
              </button>
            </div>
            }
          </div>
          }
        </span>
        } @if (!enableSameDayDocUploadForPEFC) {
        <div>
          @if (row?.uploadDocs === 'F' && !row?.flagStatus) {
          <span>N/A</span>
          } @if (row?.uploadDocs === 'S' && row?.submissionType.code != 'NBN') {
          <span>
            <button
              (click)="uploadDocs(row.individual.individualId, row.wpAppNum)"
              class="btn btn-secondary upload-btn"
            >
              Upload
              <img
                src="../../../../assets/images/cloudupload.svg"
                alt="upload-button"
                width="20px"
                height="20px"
              />
            </button>
          </span>
          } @if (row?.uploadDocs === 'S' && row?.submissionType.code === 'NBN')
          {
          <span>N/A</span>
          }
        </div>
        } @if (enableSameDayDocUploadForPEFC) {
        <div>
          @if (!row?.peAfcDocUpload) {
          <div>
            @if (row?.uploadDocs === 'F' && !row?.flagStatus) {
            <span>N/A</span>
            } @if (row?.uploadDocs === 'S' && row?.submissionType.code != 'NBN')
            {
            <span>
              <button
                (click)="uploadDocs(row.individual.individualId, row.wpAppNum)"
                class="btn btn-secondary upload-btn"
              >
                Upload
                <img
                  src="../../../../assets/images/cloudupload.svg"
                  alt="upload-button"
                  width="20px"
                  height="20px"
                />
              </button>
            </span>
            } @if (row?.uploadDocs === 'S' && row?.submissionType.code ===
            'NBN') {
            <span>N/A</span>
            }
          </div>
          } @if (row?.peAfcDocUpload === 'Y') {
          <span>
            <button
              (click)="uploadDocs(row.individual.individualId, row.wpAppNum)"
              class="btn btn-secondary upload-btn"
            >
              Upload
              <img
                src="../../../../assets/images/cloudupload.svg"
                alt="upload-button"
                width="20px"
                height="20px"
              />
            </button>
          </span>
          } @if (row?.peAfcDocUpload === 'N') {
          <span>N/A</span>
          }
        </div>
        }
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Submitted Documents">
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        @if (!row?.subDocs && row?.submissionType.code != 'IME') {
        <span>N/A</span>
        } @if (!row?.subDocs && row?.submissionType.code === 'IME') {
        <span>Uploaded</span>
        } @if (row?.subDocs) {
        <span>
          <div class="hover-red p-0">
            <a
              class="btn btn-link p-0 hover-red"
              aria-label="View"
              (click)="onSubmitDocs(row?.wpAppNum)"
            >
              <span class="pe-2">View</span>
              <svg
                id="_icons_search-outline-{{ rowIndex }}"
                data-name="⚛️ icons/search-outline"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <defs>
                  <clipPath id="clip-path-{{ rowIndex }}">
                    <rect
                      id="Background"
                      width="24"
                      height="24"
                      fill="#174a7c"
                    />
                  </clipPath>
                </defs>
                <g
                  id="Mask_Group_{{ rowIndex }}"
                  data-name="Mask Group 1"
                  clip-path="url(#clip-path)"
                >
                  <path
                    id="Combined_Shape"
                    data-name="Combined Shape"
                    d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                    transform="translate(2.25 2.25)"
                    fill="#174a7c"
                  />
                </g>
              </svg>
            </a>
          </div>
        </span>
        }
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="View Submission">
      <ng-template
        ngx-datatable-cell-template
        let-row="row"
        let-rowIndex="rowIndex"
      >
        @if (submissionType && submissionType.code === 'AD') {
        <div>N/A</div>
        } @if (!submissionType && !row?.viewSub && !row?.wpAppNum) {
        <div>
          <button
            (click)="continueApp(row)"
            class="btn btn-sm btn-secondary upload-btn"
          >
            Continue
          </button>
          <div class="pt-1 hover-red">
            <button
              class="btn btn-link btn-lg hover-red p-1"
              (click)="onDeleteApp(row.appNum)"
            >
              <span class="pe-2">Remove</span>
              <nh-remove-svg></nh-remove-svg>
            </button>
          </div>
        </div>
        } @if (!submissionType && row?.wpAppNum && (row?.viewSub || (row.appNum
        && row.lang))) {
        <span>
          <div class="hover-red p-0">
            <a
              class="btn btn-link hover-red"
              style="text-align: -webkit-left; padding-left: 0px"
              tabindex="0"
              aria-label="View English"
              (click)="onViewApp(row.viewSub, row.appNum, 'en')"
            >
              <span class="pe-2">View English</span>
              <svg
                id="search-outline-{{ rowIndex }}"
                data-name="⚛️ icons/search-outline"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <defs>
                  <clipPath id="search-path-{{ rowIndex }}">
                    <rect
                      id="Background"
                      width="24"
                      height="24"
                      fill="#174a7c"
                    />
                  </clipPath>
                </defs>
                <g
                  id="search-Mask_Group_{{ rowIndex }}"
                  data-name="Mask Group 1"
                  clip-path="url(#clip-path)"
                >
                  <path
                    id="Combined_Shape"
                    data-name="Combined Shape"
                    d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                    transform="translate(2.25 2.25)"
                    fill="#174a7c"
                  />
                </g>
              </svg>
            </a>
          </div>
        </span>
        } @if (!submissionType && row?.wpAppNum && (row?.viewSubSP ||
        (row.appNum && row.lang === 'sp'))) {
        <span>
          <div class="hover-red p-0">
            <a
              class="btn btn-link hover-red"
              style="text-align: -webkit-left; padding-left: 0px"
              tabindex="0"
              aria-label="View Spanish"
              (click)="onViewApp(row.viewSubSP, row.appNum, 'sp')"
            >
              <span class="pe-2">View Spanish</span>
              <svg
                id="search-outline-{{ rowIndex }}"
                data-name="⚛️ icons/search-outline"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <defs>
                  <clipPath id="search-path-{{ rowIndex }}">
                    <rect
                      id="Background"
                      width="24"
                      height="24"
                      fill="#174a7c"
                    />
                  </clipPath>
                </defs>
                <g
                  id="search-Mask_Group_{{ rowIndex }}"
                  data-name="Mask Group 1"
                  clip-path="url(#clip-path)"
                >
                  <path
                    id="Combined_Shape"
                    data-name="Combined Shape"
                    d="M18.232,19.292l-.013-.012-4.927-4.927a8.122,8.122,0,1,1,1.061-1.061l4.927,4.927a.75.75,0,0,1-1.049,1.073ZM1.5,8.114A6.614,6.614,0,1,0,8.114,1.5,6.621,6.621,0,0,0,1.5,8.114Z"
                    transform="translate(2.25 2.25)"
                    fill="#174a7c"
                  />
                </g>
              </svg>
            </a>
          </div>
        </span>
        }
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>